import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=385f81e9"
import script from "./UserSearch.vue?vue&type=script&lang=js"
export * from "./UserSearch.vue?vue&type=script&lang=js"
import style0 from "./UserSearch.vue?vue&type=style&index=0&id=385f81e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports